/**
 * PaymentMethodSelector
 *
 * Credit card / Apple Pay toggle selector.
 * Same pattern as GuestPortalCheckout PaymentMethodItem.
 */

import { memo } from 'react';
import { IPaymentMethodSelectorProps } from '../../types';
import {
  PaymentMethodsContainer,
  PaymentMethodCard,
  PaymentMethodIcon,
  PaymentMethodInfo,
  PaymentMethodTitle,
  PaymentMethodDescription,
  PaymentMethodRadio,
} from '../../styles';

const PaymentMethodSelector = memo(({
  methods,
  selectedMethodId,
  onSelect,
}: IPaymentMethodSelectorProps) => {
  return (
    <PaymentMethodsContainer>
      {methods.map((method) => (
        <PaymentMethodCard
          key={method.id}
          $isSelected={method.id === selectedMethodId}
          $disabled={method.disabled}
          onClick={() => !method.disabled && onSelect(method.id)}
        >
          <PaymentMethodRadio
            type="radio"
            checked={method.id === selectedMethodId}
            onChange={() => onSelect(method.id)}
            disabled={method.disabled}
          />
          <PaymentMethodIcon>{method.icon}</PaymentMethodIcon>
          <PaymentMethodInfo>
            <PaymentMethodTitle>{method.title}</PaymentMethodTitle>
          </PaymentMethodInfo>
        </PaymentMethodCard>
      ))}
    </PaymentMethodsContainer>
  );
});

export default PaymentMethodSelector;
